import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


//css
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css'


//reudx
// import { createStore } from 'redux'
// //allows any pages to use the store
// import { Provider } from 'react-redux'
//import { composeWithDevTools } from "redux-devtools-extension"


import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';

//import rootReducer, since it index file you don't have to call it
import {rootPersistConfig, rootReducer} from "./reducers"


//const store = createStore(rootReducer, composeWithDevTools())


import { PersistGate } from 'redux-persist/lib/integration/react';

import { Provider } from 'react-redux';

import { ErrorBoundary } from 'react-error-boundary';
import NotFound from './components/404/404'
const store = configureStore({
  reducer: persistReducer(rootPersistConfig, rootReducer),
  middleware: getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  }),
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

// const ErrorFallback = ({ error, resetErrorBoundary }) => {
//   return (
//     <div role="alert">
//       <p>Something went wrong:</p>
//       <pre>{error.message}</pre>
//       <button onClick={resetErrorBoundary}>Try again</button>
//     </div>
//   );
// };


ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={NotFound}>
    <Provider store={store}>
    <PersistGate  persistor={persistor}>
     <App />
     </PersistGate>
    </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
